import { RemoveDuplicateItems } from "helpers/Utils";
import { SelectItem } from "types/Common";
import { IPackage } from "types/package";

export const useFilterItems = (packages: IPackage[]) => {
  const durationDay: SelectItem[] = packages.flatMap(p =>
    p.tours.map(t => ({
      value: t.durationDays,
      label: `${t.durationDays} Dias`
    }))
  );
  const durationDayItems = RemoveDuplicateItems(durationDay);
  const tourTypes: SelectItem[] = packages.flatMap(p =>
    p.tours.flatMap(t =>
      t.types.map(v => ({
        value: v.id,
        label: v.name
      }))
    )
  );
  const tourTypesItems = RemoveDuplicateItems(tourTypes);
  const modalities: SelectItem[] = packages.flatMap(p =>
    p.tours.map(t => ({
      value: t.modality?.id as string,
      label: t.modality?.name as string
    }))
  );
  const modalitiesItems = RemoveDuplicateItems(modalities);
  return { durationDayItems, tourTypesItems, modalitiesItems };
};
